/**
 * jrs-team-addon.js — thank-you page add-on landing (/pages/team-addon), 2026-10-16.
 *
 * Arrives from the JRS checkout app's thank-you block (design C v2) with:
 *   b, bq  beanie colour + quantity (1–50), optional
 *   k, kq  cap colour + quantity (1–50), optional; at least one item required
 *   lid, lu, lf  logo id, logo URL (https://jrsindustrial-files.com/ only), logo filename,
 *                copied from the order just placed
 *   ref  order confirmation number (packing note + reporting)
 *   exp  when the 10-minute offer ends (ms since epoch)
 *
 * After exp the page shows "This offer has ended" and adds nothing, so the half price is never
 * applied late. Before exp: builds the lines with JRS.CartPayloadBuilder.build({ type: 'standard' }),
 * the same path the customiser and BYOB use, so Position / Application Method / Logo Id /
 * Logo Type / Logo / Logo Filename / _ParentVariant are written exactly as today (order-alerts
 * reads them). Adds _jrs_addon + _jrs_addon_ref to every line so Jim's team can pack the add-on
 * with the first order; underscore keys are ignored by the tracker. One POST per item through
 * JRS.CartAPI.addItems, then /checkout with the section's discount code(s) (set up by Jim).
 */
(function () {
  'use strict';

  // Product + paid embroidery position per offer. Variant ids read from the Admin API 2026-10-16:
  // "Beanie Front" / "Cap Front" Embroidery (£9.00) are the paid position products the customiser uses.
  var OFFERS = [
    { key: 'beanie', param: 'b', handle: 'b45', positionName: 'Beanie Front', positionVariantId: 56432958865781, noun: ['beanie', 'beanies'] },
    { key: 'cap', param: 'k', handle: 'b10', positionName: 'Cap Front', positionVariantId: 43634196119795, noun: ['cap', 'caps'] }
  ];
  var LOGO_HOST = 'https://jrsindustrial-files.com/';
  var MAX_QTY = 50;
  var MAX_LINK_AGE = 15 * 60 * 1000; // an exp further out than this was not made by the block

  var root = document.querySelector('[data-jrs-team-addon]');
  if (!root) return;

  function q(name) { return new URLSearchParams(location.search).get(name) || ''; }
  function push(ev) { try { (window.dataLayer = window.dataLayer || []).push(ev); } catch (e) {} }

  function show(state, title, text) {
    root.setAttribute('data-state', state);
    root.querySelector('[data-addon-title]').textContent = title;
    root.querySelector('[data-addon-text]').hidden = true;
    root.querySelector('[data-addon-' + state + ']').hidden = false;
  }

  function fail(reason) {
    show('error', 'Nearly there');
    push({ event: 'jrs_addon_failed', addon_reason: String(reason).slice(0, 100) });
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (ch) {
      var r = (Math.random() * 16) | 0; return (ch === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }

  // The jrs-v2 modules load deferred from layout/theme.liquid; wait for them (max ~5s).
  function whenReady() {
    return new Promise(function (resolve, reject) {
      var tries = 0;
      (function poll() {
        if (window.JRS && JRS.CartPayloadBuilder && JRS.CartAPI && JRS.PDP_TYPES) return resolve();
        if (++tries > 100) return reject(new Error('modules not loaded'));
        setTimeout(poll, 50);
      })();
    });
  }

  function goCheckout() {
    var code = root.getAttribute('data-discount');
    location.href = code ? '/checkout?discount=' + code.split(',').map(function (c) { return encodeURIComponent(c.trim()); }).filter(Boolean).join(',') : '/checkout';
  }

  var exp = Number(q('exp'));
  var logoUrl = q('lu');
  var logoId = q('lid');
  var picks = OFFERS.map(function (o) {
    return { offer: o, colour: q(o.param), qty: Math.floor(Number(q(o.param + 'q'))) };
  }).filter(function (p) { return p.colour && p.qty >= 1; });

  if (!(exp > 0) || exp > Date.now() + MAX_LINK_AGE) return fail('bad expiry');
  if (Date.now() > exp) {
    show('ended', 'This offer has ended');
    push({ event: 'jrs_addon_expired' });
    return;
  }
  if (!picks.length) return fail('nothing picked');
  if (picks.some(function (p) { return p.qty > MAX_QTY; })) return fail('bad quantity');
  if (!logoId || logoUrl.indexOf(LOGO_HOST) !== 0) return fail('bad logo');

  // A reload or back-button visit must not add the same items twice.
  var doneKey = 'jrs_addon_done_' + [q('ref'), q('b'), q('bq'), q('k'), q('kq')].join('|');
  try { if (sessionStorage.getItem(doneKey)) return goCheckout(); } catch (e) {}

  root.querySelector('[data-addon-title]').textContent = 'Adding ' + picks.map(function (p) {
    return p.qty + ' ' + p.offer.noun[p.qty > 1 ? 1 : 0];
  }).join(' and ') + ' with your logo…';

  function variantFor(p) {
    return fetch('/products/' + p.offer.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (product) {
        var colour = p.colour.toLowerCase();
        var variant = product.variants.filter(function (v) {
          return v.available && String(v.option1 || '').toLowerCase() === colour;
        })[0];
        if (!variant) throw new Error(p.offer.key + ' colour unavailable');
        return { pick: p, product: product, variant: variant };
      });
  }

  function build(x) {
    var built = JRS.CartPayloadBuilder.build({
      type: JRS.PDP_TYPES.STANDARD,
      instanceId: uuid(),
      categories: [{
        name: x.product.title,
        index: 0,
        products: [{
          productId: x.product.id,
          productHandle: x.product.handle,
          productTitle: x.product.title,
          variantId: x.variant.id,
          colour: x.variant.option1 || '',
          imageUrl: x.variant.featured_image ? x.variant.featured_image.src : (x.product.featured_image || null),
          sizes: [{ size: x.variant.option2 || 'One Size', quantity: x.pick.qty, variantId: x.variant.id, sku: x.variant.sku || null }]
        }]
      }],
      customization: {
        positions: [{
          id: uuid(),
          positionName: x.pick.offer.positionName,
          positionVariantId: x.pick.offer.positionVariantId,
          applicationMethod: 'Embroidery',
          categoryIndex: 0,
          sourceLogoGroupId: null,
          logo: { type: 'upload', logoId: String(logoId), url: logoUrl, filename: q('lf') || null, text: null, note: '' }
        }]
      }
    });
    built.items.forEach(function (item) {
      item.properties = item.properties || {};
      item.properties._jrs_addon = 'thankyou';
      if (q('ref')) item.properties._jrs_addon_ref = q('ref').slice(0, 40);
    });
    return built;
  }

  // Check every colour before adding anything, so a sold-out colour never leaves half an add-on.
  Promise.all(picks.map(variantFor))
    .then(function (found) {
      return whenReady().then(function () {
        var payloads = found.map(build);
        return payloads.reduce(function (chain, payload, i) {
          return chain.then(function () {
            return JRS.CartAPI.addItems(payload, { skipCartRefresh: i < payloads.length - 1 }).then(function (res) {
              // addItems resolves with ok:false on a failed add rather than rejecting.
              if (!res || !res.ok) throw new Error((res && res.error) || 'add failed');
            });
          });
        }, Promise.resolve());
      });
    })
    .then(function () {
      try { sessionStorage.setItem(doneKey, '1'); } catch (e) {}
      push({ event: 'jrs_addon_added', addon_beanies: Number(q('bq')) || 0, addon_caps: Number(q('kq')) || 0 });
      goCheckout();
    })
    .catch(function (err) { fail(err && err.message || 'add failed'); });
})();
